"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.exhaustCheck=exhaustCheck;function exhaustCheck(a){throw new Error("Reaching an impossible state because of ".concat(a))}
//# sourceMappingURL=helpers.js.map